module.exports = __webpack_public_path__ + "static/media/xcultural3.df45c507.jpg";